import { db } from '@/api/firebaseInit';
import { store } from '@/api/store';
import firebase from 'firebase';


const Items = store.getters.users;

const getUserById = (uuid) => {
  return (uuid === undefined) ? Items[0] : Items.find(item => item.id === uuid);
};

const getUser = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items;
};

export {
  Items,
  getUser,
  getUserById
};


// WEBPACK FOOTER //
// ./src/api/user.js